<template>
  <div class="qrcodeTemplate">
    <el-dialog
      :visible.sync="isWatch"
      width="350px"
      @close="close"
      title="账号凭证"
      v-if="isWatch"
    >
      <div
        class="QRCodeBox"
        ref="qrCodeUrl"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      ></div>
      <div slot="footer" class="dialog-footer"></div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      isWatch: false,
      qrUrl: "",
      uid: "",
      loading: false,
    };
  },
  created() {},
  methods: {
    // 打开弹窗、传递需要编辑的参数
    open(row) {
      this.uid = row.uid;
      this.isWatch = true;
      this.getQrcode();
    },
    // 关闭弹窗
    close() {
      this.uid = "";
      this.qrUrl = "";
    },
    getQrcode() {
      let req = {
        uid: this.uid,
      };
      (this.loading = true),
        API.getQrcode(req)
          .then((res) => {
            if (res.code === 200) {
              this.qrUrl = res.data;
              this.createQrcode();
            } else {
              this.$message.error("查询账号凭证失败");
            }
          })
          .catch(() => {
            this.loading = false;
            this.$message.error("查询账号凭证失败");
          })
          .finally(() => {
            this.loading = false;
          });
    },
    createQrcode() {
      this.$nextTick(() => {
        this.qrcode = new QRCode(this.$refs.qrCodeUrl, {
          text: this.qrUrl,
          width: 180,
          height: 180,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.L,
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.QRCodeBox {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
